import { render, staticRenderFns } from "./fightcamp-elite.vue?vue&type=template&id=5e688442&"
import script from "./fightcamp-elite.vue?vue&type=script&lang=ts&"
export * from "./fightcamp-elite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ReviewsGrid: require('/opt/build/repo/apps/shop/components/storyblok/ReviewsGrid/ReviewsGrid.vue').default})
